// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1fE_d","author":"Table_author__31xM2","authorImage":"Table_authorImage__34O-V","unreadRow":"Table_unreadRow__288yx"};